import React, { useState } from "react";
import MuiButton from "@mui/material/Button";

const ReadMore = ({ expanded = false, comment, maxChar = 100 }) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const maxCharCount = maxChar; // Maximum characters to show when collapsed

  const handleToggle = (event) => {
    setIsExpanded(!isExpanded);
    event.preventDefault();
  };

  const truncatedText =
    comment?.length > maxCharCount && !isExpanded
      ? `${comment.slice(0, maxCharCount)}.....`
      : comment;

  return (
    <>
      {truncatedText}

      {comment?.length > maxCharCount && (
        <MuiButton
          size="small"
          sx={{
            ml: "5px",
            p: 0,
            color: "#1976d2",
            textTransform: "none",
            display: "inline",
          }}
          onClick={(e) => handleToggle(e)}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </MuiButton>
      )}
    </>
  );
};

export default ReadMore;
